import { render, staticRenderFns } from "./CmgRetroCreditInfoCard.vue?vue&type=template&id=08a38d0f&scoped=true&lang=pug"
import script from "./cmg-retro-credit-info-card.ts?vue&type=script&lang=ts&external"
export * from "./cmg-retro-credit-info-card.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRetroCreditInfoCard.vue?vue&type=style&index=0&id=08a38d0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a38d0f",
  null
  
)

export default component.exports